import React from "react";
import ReferralsSummary from "./sections/ReferralsSummary";
import ReferralsTable from "./sections/ReferralsTable";

const Referrals = () => {
  return (
    <div className="mx-6">
      <ReferralsSummary />
      <ReferralsTable />
    </div>
  );
};

export default Referrals;
